
import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getSerialHistoryReport } from "../store/api/Services";
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import BihamtaTable from "../../Components/BihamtaTable";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";

export default function SerialHistoryReport() {
    const dispatch = useDispatch();
    const history = useHistory();
    const inputDateFrom = useRef();
    const inputDateTo = useRef();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [popProduct, setPopProduct] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const { handleSubmit, register } = useForm();
    const settingNames = ["ProductGrouppingType"];
    const { settings, filterData } = useSelector(state => { return { settings: state.SystemSettingsReducer.systemSettings, filterData: state.service.serialHistoryReportFilters } });
    const pgType = Number(settings.find?.(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "ProductHolder", colTitle: "مارک کالا", showInMobile: true, showCondition: () => Number(pgType) !== 1 },
        { colName: "ProductName", colTitle: (Number(pgType) !== 1 ? "نوع کالا" : "نام کالا"), showInMobile: true },
        { colName: "ProductModel", colTitle: "مدل کالا", showInMobile: true },
        { colName: "SerialNumber", colTitle: "سریال کالا", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colName: "POperatorType", colTitle: "نوع گردش" },
        { colName: "PHistoryDate", colTitle: "تاریخ گردش" },
        { colName: "OperatorNumber", colTitle: "شماره گردش" }
    ]
    function showModalProduct(e) {
        if (e.key) {
            if (e.key === "Enter" || e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }

        const setData = (data) => {
            if (data) {
                data.ProductName += '- ' + data.ProductModel;
                if (pgType !== 1) {
                    data.ProductName = data.HolderName + "- " + data.ProductName;
                }
            }
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, forStorageReport: true });
    }
    function toExcel() {
        const url = "api/GuarantyAPI/GetSerialHistoryReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SerialHistoryReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function print(e) {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "SerialHistoryReport" });
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const pDateFrom = inputDateFrom.current.input.value;
        data.PHistoryDateFrom = pDateFrom;
        if (pDateFrom !== "") {
            data.HistoryDateFrom = inputDateFrom.current.state.momentValue?.local("en").format("YYYY-MM-DD");
        }
        const pDateTo = inputDateTo.current.input.value;
        if (pDateTo !== "") {
            data.HistoryDateTo = inputDateTo.current.state.momentValue?.local("en").format("YYYY-MM-DD");
        }
        data.Skip = 0;
        data.Take = data.Take ?? 0;
        dispatch(getSerialHistoryReport(data));
    }
    function tableRowClick(row) {
        const ot = row.OperatorType?.toLowerCase();
        if (ot === "repair" || ot === "install") {
            history.push(`/Services/Service/${row.OperatorID}/${ot}`, null);
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات پس از فروش";
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData}
                dataUrl="api/GuarantyAPI/GetSerialHistoryReport"
                method="post"
                fetchBody={{ ...filterData, Take: 0, Skip: 0 }} />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} hideNewProduct={true}
                defaultSalePrice="" defaultSalePriceLabel="" />
            <Card>
                <Card.Header className="headerStyle">گزارش تاریخچه سریالها</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>

                            <Col md={2} className="form-group">
                                <label>سریال کالا:</label>
                                <Form.Control name="SerialNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشخصات کالا:</label>
                                <input type="hidden" name="RelatedProductID" ref={register({})} value={selectedProduct?.ProductID ?? filterData?.RelatedProductID ?? ""} />
                                <Form.Control readOnly onKeyDown={showModalProduct} name="ProductName" ref={register({})}
                                    value={selectedProduct?.ProductName ?? filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 26 }}><List size={23} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel" title="تاریخ گردش از">تاریخ گردش از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="HistoryDateFrom" ref={inputDateFrom}
                                    /*onChange={value => filterData.current.HistoryDateFrom = value.local("en").format("YYYY-MM-DD")} */ />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel" title="تاریخ گردش تا">تاریخ گردش تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="HistoryDateFrom" ref={inputDateTo}
                                    /*onChange={val => filterData.current.ContactDateTo = val.local("en").format("YYYY-MM-DD")}*/ />
                            </Col>

                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel" title="تعداد در صفحه">تعداد در صفحه:</label>
                                <select className="form-control" name="Take" ref={register({})}>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>
                                </select>
                            </Col>
                        </Row>

                        <div>
                            <Button type="submit" className="group-Btn-large mt-1" variant="secondary" ><Search size={18} />&nbsp;نمایش گزارش </Button>
                        </div>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <Printer onClick={print} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>
                    }
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} columns={tableCols} filterData={filterData} searchMethod={(data) => dispatch(getSerialHistoryReport(data))}
                        reducerName="service" objectName="serialHistoryReport" style={{ whiteSpace: "nowrap" }} className="mt-0 mb-0" maxHeight={500} rowClick={tableRowClick} />
                </Card.Body>
            </Card>
        </div>
    )
}